// Styles have been copied to packages/editor/generative-ai-modal/examples/utils/components/Modals.tsx
// Updates to this file should also be copied to there.
import { css } from '@emotion/react';
import { N0 } from '@atlaskit/theme/colors';
export const styleDiv = css({
  position: 'relative',
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center'
});
export const styleIconBackground = css({
  backgroundColor: `var(--ds-surface-overlay, ${N0})`
});
export const styleBorder = css({
  position: 'absolute',
  left: '0px',
  top: '0px',
  right: 0,
  bottom: 0
});